<template>
  <section-layout
    :showButton="false"
  >
    <template v-slot:title>
      {{localization.tabsTitles.encuestas}}
    </template>
    <template v-slot:content>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <o-medium-title class="pr-5">
              {{localization.filtros.title}}
            </o-medium-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <filtroEncuestas
              :disabled="loading"
              @aplicar="aplicarFiltros"
              @borrar="borrarFiltros"
              @exportar="exportarExcel"
              :itramit="true"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card class="mt-4">
        <v-container fluid>
          <v-data-table
            :headers="headers"
            :items="incidencias"
            :loading="loading"
            item-key="incidenciaId"
            :footer-props="{
              'items-per-page-text': $t('filasPorPagina'),
              'items-per-page-options': [10, 20, 30, 40, 50, -1]
            }"
          >
            <template
              v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.idEncuesta">
                  <!--<td>{{ item.incidenciaId }}</td>-->
                  <td>{{ item.propertyDevelopment }}</td>
                  <td>{{ item.referencia }}</td>
                  <td>{{ item.uhedit }}</td>
                  <td>{{ item.description }}</td>
                  <td>{{ item.room }}</td>
                  <td>{{ item.estadoEncuesta }}</td>
                  <td>{{ item.fechaCreacionEncuesta }}</td>
                  <td>{{ item.fechaRespuestaEncuesta }}</td>
                  <td>{{ /* componerValor(item)*/ item.valor }}</td>
                  <td>{{ `${item.codCliente} - ${item.cliente}` }}</td>
                  <td>{{ item.emailCliente }}</td>
                  <td>{{ item.state }}</td>
                </tr>
              </tbody>
            </template>
            <!-- <template v-slot:item.location="{item}">
              <div v-html="item.location"/>
            </template> -->
          </v-data-table>
        </v-container>
      </v-card>
    </template>
  </section-layout>
</template>

<script>
import { mapActions } from 'vuex'
import filtroEncuestas from './filtrosEncuestas'
import mixinExcel from '@/mixins/downloadExcel'

export default {
  mixins: [mixinExcel],
  components: {
    filtroEncuestas
  },
  data () {
    return {
      loading: false,
      buscador: '',
      incidencias: [],
      loader: null
    }
  },
  computed: {
    localization () {
      return this.$t('sectionInformes')
    },
    headers () {
      return [
        { text: this.localization.encuestas.promocion, value: 'propertyDevelopment', sortable: true },
        { text: this.localization.encuestas.numIncidencia, value: 'referencia', sortable: true },
        { text: this.localization.encuestas.inmueble, value: 'uhedit', sortable: true },
        { text: this.localization.encuestas.descripcion, value: 'description', sortable: true },
        { text: this.localization.encuestas.localizacion, value: 'room', sortable: true },
        { text: this.localization.encuestas.estado, value: 'estadoEncuesta', sortable: true },
        { text: this.localization.encuestas.fechaEstado, value: 'fechaCreacionEncuesta', sortable: true },
        { text: this.localization.encuestas.fechaEncuesta, value: 'fechaRespuestaEncuesta', sortable: true },
        { text: this.localization.encuestas.valoracion, value: 'valor', sortable: true },
        { text: this.localization.encuestas.cliente, value: 'cliente', sortable: true },
        { text: this.localization.encuestas.correoCliente, value: 'emailCliente', sortable: true },
        { text: this.localization.encuestas.estadoActual, value: 'state', sortable: true }
      ]
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getEncuestas: 'informes/getEncuestas'
    }),
    async aplicarFiltros (values) {
      // console.log('VALUES: ', values.codigoTipoSolicitud)
      try {
        this.loading = true
        var respuesta = await this.getEncuestas(values)
        this.incidencias = respuesta.data
      } catch (error) {
        console.log('ERROR AL CARGAR DATOS? filtros', error)
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.loading = false
    },
    borrarFiltros () {
      this.incidencias = []
    },
    componerValor(item) {
      return (item.valor) ? item.valor + ' - ' + item.descripcion : ''
    },
    async exportarExcel (values) {
      try {
        this.loading = true
        let csv = await this.getEncuestas(values)
        this.downloadExcel(csv.file || csv.data)
      } catch (error) {
        console.log('ERROR AL CARGAR DATOS? descarga', error)
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.recortarStyle {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 150px;
  }
</style>
